import * as React from 'react';

const SearchShieldIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={32}
      height={32}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h32v32H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#004A68"
        d="M16.001 27.948c-2.684-.795-4.91-2.43-6.68-4.904-1.768-2.474-2.653-5.255-2.653-8.342V7.589l9.333-3.487 9.334 3.487v7.113c0 1.425-.197 2.847-.589 4.265-.392 1.418-1.069 2.818-2.03 4.199l-4.307-4.21a4.453 4.453 0 0 1-1.142.612 3.7 3.7 0 0 1-1.266.22c-1.067 0-1.974-.372-2.72-1.118-.745-.746-1.118-1.65-1.118-2.716 0-1.065.372-1.972 1.117-2.72.745-.748 1.65-1.122 2.716-1.122 1.066 0 1.973.374 2.721 1.122.749.748 1.123 1.656 1.123 2.724 0 .423-.067.824-.2 1.2-.134.378-.31.73-.531 1.056l3.395 3.339a13.363 13.363 0 0 0 1.328-3.178 13.69 13.69 0 0 0 .477-3.673V8.239l-8.308-3.022-8.307 3.022v6.463c0 2.791.78 5.32 2.34 7.588 1.56 2.268 3.55 3.798 5.974 4.591.606-.178 1.263-.472 1.972-.882.708-.41 1.32-.837 1.837-1.28l.63.793c-.675.54-1.38 1.02-2.116 1.44-.736.42-1.513.751-2.33.996Zm.007-9.185c.767 0 1.426-.27 1.978-.812s.828-1.212.828-2.01c0-.765-.278-1.423-.835-1.975-.556-.552-1.218-.829-1.984-.829-.767 0-1.426.277-1.978.829-.553.552-.829 1.21-.829 1.975 0 .798.279 1.468.835 2.01a2.749 2.749 0 0 0 1.985.812Z"
      />
    </g>
  </svg>
);

export default SearchShieldIcon;
